let _ = require('lodash');
let computedPrice = require('./computed/data');
let { thenWithErrorHandling } = require('../helpers/errorHandler');

module.exports = {
    setComputedFields (args, state) {
        computedPrice.formatPrices(state);
        computedPrice.formatDiscounts(state);
        computedPrice.formatExportColumns(state);
    },

    getPrices (args, state, output, { context, locator }) {
        let api = locator.resolve('api');
        let request = api.getPrices(context, locator, {});

        thenWithErrorHandling(
            request,
            (data) => ({ prices: _.get(data, 'content') }),
            output);
    },

    setPrices ({ prices }, state) {
        state.set(['data'], prices);
    },

    getColumns (args, state, output, { context, locator }) {
        let api = locator.resolve('api');
        let request = api.getColumns(context, locator, {});
        thenWithErrorHandling(
            request,
            (data) => ({ columns: _.get(data, 'content') }),
            output);
    },

    setColumns ({ columns }, state) {
        state.set(['data', 'columns'], columns);
    },
};



// WEBPACK FOOTER //
// ./actions/prices.js